/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var Input_1 = require("./Input");
// Using `import` here results in ReactInputMask being undefined
var ReactInputMask = require("react-input-mask");
// Due to weird typing issues with @types/react-input-mask we have to do this.
// Basically typescript thinkgs, ReactInputMask would be undefined, and
// ReactInputMask.default would be the actual component. But the opposite is the case.
var CastedReactInputMask = ReactInputMask;
var InputMasked = /** @class */ (function (_super) {
    tslib_1.__extends(InputMasked, _super);
    function InputMasked() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InputMasked.prototype.render = function () {
        var _a = this.props, _b = _a.input, input = _b === void 0 ? Input_1.Input : _b, mask = _a.mask, maskChar = _a.maskChar, formatChars = _a.formatChars, alwaysShowMask = _a.alwaysShowMask, props = tslib_1.__rest(_a, ["input", "mask", "maskChar", "formatChars", "alwaysShowMask"]);
        var TagName = input;
        return (React.createElement(TagName, tslib_1.__assign({ renderInput: function (baseInputProps) { return (React.createElement(CastedReactInputMask, tslib_1.__assign({}, baseInputProps, { mask: mask, maskChar: maskChar, formatChars: formatChars, alwaysShowMask: alwaysShowMask }))); } }, props)));
    };
    InputMasked.propTypes = tslib_1.__assign({}, Input_1.Input.propTypes, { 
        // @ts-ignore
        input: PropTypes.func, mask: PropTypes.string, maskChar: PropTypes.string, formatChars: PropTypes.string, alwaysShowMask: PropTypes.bool });
    InputMasked.defaultProps = tslib_1.__assign({}, Input_1.Input.defaultProps, { input: Input_1.Input });
    return InputMasked;
}(React.Component));
exports.InputMasked = InputMasked;